<template>
  <div class="page-template add-page order-add-page" v-loading="loading">
    <div class="page-title">{{ title }}</div>
    <div class="btn-box">
      <el-button @click="beBack" type="primary" plain>返回</el-button>
      <el-button @click="refresh" type="primary" plain>刷新</el-button>
      <el-button @click="submitAuth" type="primary" plain :disabled="buttonShow">保存</el-button>
      <el-button @click="audit" type="primary" plain :disabled="auditShow">审核</el-button>
      <el-button @click="complexFunc" type="primary" plain
      >{{ complexShow ? "收起" : "展开" }}
        <i class="el-icon-arrow-up" v-show="complexShow"></i>
        <i class="el-icon-arrow-down" v-show="!complexShow"></i>
      </el-button>
    </div>
    <list-operation-form v-show="complexShow" ref="listOperationForm" :formOptions="listFormOptions"
                         @valueChange="listFormValueChange"></list-operation-form>
    <div class="search-goods-box">
      <el-input id="goodsText"
                placeholder="条码/自编码/助记码"
                v-model="goodsTxt"
                class="search-goods-input"
                @change="search"
      >
        <template slot="prepend">
          <span>综合搜索</span>
        </template>
        <template slot="append">
          <!--<div class="el-icon-search more-btn" @click="search"></div>-->
          <div class="el-icon-search more-btn"></div>
        </template>
      </el-input>
      <el-button @click="checkGoods" type="primary" plain class="select-good"
      >选择商品
      </el-button
      >
      <!--<el-button @click="downloadTemplate" type="primary" plain>下载模板</el-button>-->
      <!--<el-button @click="importData" type="primary" plain>导入商品</el-button>-->
    </div>
    <list-operation-new
      ref="listOperation"
      :tableOptions="listColumns"
    ></list-operation-new>
    <el-dialog title="商品列表" :visible.sync="listShow" width="1200px" height="800"
               :close-on-click-modal="false">
      <good-list
        v-if="listShow"
        ref="goodList"
        @rowCheck="rowCheck"
        :isSelect="goodListSelect"
        :tableOptions="tableOptions"
        :searchAuto="searchAuto"
        :otherParam="otherParam"
        @selectSubmit="rowsSelectSubmit"
        :selectUrl="selectUrl"
        :listTableData="listTableData"
      ></good-list>
    </el-dialog>
  </div>
</template>
<script>
//商品列表组件
import goodList from '@/components/business/goodList';
//添加要货单组件
import listOperationNew from "@/components/template/listOperationNew";
//要货单搜索组件
import listOperationForm from '@/components/template/listOperationForm';
import api from '@/config/api';
import userPower from '@/mixin/userPower';

export default {
  mixins: [userPower],
  components: {
    listOperationNew,
    goodList,
    listOperationForm
  },
  data() {
    return {
      isCheck: false,
      complexShow: true,
      goodsTxt: "",
      listTableData: [],
      searchAuto: false,//自动检索
      goodListSelect: false,
      loading: false,
      title: '',
      listShow: false,
      goodList: [],
      auditShow: true,
      buttonShow: false,
      formModel: {},
      dialogShow: false,
      otherParam: {statusList: [10, 20, 30], isOpenCombination: 1},
      selectUrl: {url: api.archives.asGoodsSpecsMap},
      //条件
      listFormOptions: {
        disabled: false,
        statusOption: {
          prop: 'reviewerStatus',
          statusImg: {
            10: '/static/checked.png',
            20: '/static/un-check.png'
          }
        },
        labelWidth: '130px',
        columns:
          [
            {
              label: '业务单号：',
              type: 'input',
              prop: 'orderNo',
              labelKey: 'orderNo',
              uniqueKey: 'orderNo',
              disabled: true,
              span: 12,
            },
            {
              type: 'input',
              prop: 'id',
              hidden: true
            },
            // {
            //   label: '调价级别',
            //   type: 'select',
            //   prop: 'relateType',
            //   data: this.$utils.getCacheStatus('asPriceAdjustmentOrder.relateType'),
            //   hidden: true,
            //   span: 12,
            // },
            {
              label: "调价门店",
              type: "storeInputDialog",
              prop: "storeId",
              span: 8,
              disabled: false,
              isHasAll: true, // 下拉选择添加‘总部’字段
            },
            // {
            //   label: '调价门店',
            //   type: 'storeInputDialog',
            //   prop: 'storeId',
            //   data: [],
            //   span: 12,
            //   url: api.store.store,
            //   isHasAll: true,
            //   change: this.getSelectParam,
            //   rule: [{required: true, message: "请选择门店", trigger: "blur"}],
            // },
            {
              label: '备注：',
              type: 'input',
              prop: 'remarks',
              span: 12,
            },
          ]
      },
      //添加表格字段
      listColumns: {
        hideSum: true,
        summaryColumns: [
          "differencePrice"
        ],
        disabled: false,
        indexShow: true,//是否显示索引
        columns: [
          {label: '操作', type: 'operation', width: 100, prop: 'operation'},
          {label: '序号', type: 'index', width: 60, prop: 'idx'},
          {
            label: '条码',
            prop: 'barCode',
            // type: 'input',
            width: '150',
          },
          {
            label: '商品名称',
            prop: 'goodsName',
            width: '100',
          },
          {
            label: '规格',
            prop: 'specs',
            width: '60'
          },
          {
            label: '库存数量',
            prop: 'goodsNum',
            width: '100'
          },
          {
            label: '单位',
            prop: 'unitName',
            width: '100'
          },
          {
            label: '原成本价',
            prop: 'purchasePrice',
            align: 'center',
            width: '110',
          },
          {
            label: '现成本价',
            type: 'inputNumber',
            prop: 'paPurchasePrice',
            align: 'center',
            width: '110',
            precision: 2,
            change: this.purchaseChange
          },
          {
            label: '调价差额',
            type: 'selfData',
            prop: 'differencePrice',
            align: 'center',
            width: '110',

          },
          {
            label: '备注',
            prop: 'remarks',
            type: 'input',
            width: 200
          }

        ],
        url: api.warehouse.adjustmentOrder
      },
      //表格信息配置
      tableOptions: {
        indexShow: true,//是否显示索引
        indexMethod: (index) => {//自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '条码',
            prop: 'barCode',
            width: '190',
            align: 'center'
          },
          {
            label: "品名",
            prop: "goodsName",
            width: "140",
            align: "center"
          },
          {
            label: "自编码",
            prop: "artNo",
            width: "100",
            align: "center"
          },
          {
            label: '数量',
            prop: 'inventoryNum',
            width: 80,
            align: 'center'
          },
          {
            label: "规格",
            prop: "specs",
            width: "100",
            align: "center"
          },
          {
            label: "单位",
            prop: "unitName",
            width: "100",
            align: "center"
          },
          {
            label: "零售价",
            prop: "retailPrice",
            width: "100",
            align: "center"
          },
          {
            label: "最低零售价",
            prop: "lowestPrice",
            width: "120",
            align: "center"
          },
          {
            label: "会员价",
            prop: "vipPrice",
            width: "100",
            align: "center"
          },
          {
            label: "Plus会员价",
            prop: "plusVipPrice",
            width: "120",
            align: "center"
          },
          {
            label: "批发价",
            prop: "tradePrice",
            width: "100",
            align: "center"
          },
          {
            label: "配送价",
            prop: "deliveryPrice",
            width: "100",
            align: "center"
          },
          {
            label: "进货价",
            prop: "buyPrice",
            width: "100",
            align: "center"
          },
        ],
        url: api.archives.goodsInfoIncludeSpecs,
        params: this.otherParam
      },
      checkIndex: '',
      supplierInfo: {}
    }
  },
  created() {
    this.title = document.title + (this.$route.query.id ? '编辑' : '新增');
    if (this.$route.query.id) {
      this.getDetail(this.$route.query.id);
    }
    this.setStore();
  },
  methods: {
    //点击 高级搜索显示
    complexFunc() {
      if (!this.isCheck) {
        this.complexShow = !this.complexShow;
      }
    },
    listFormValueChange(value, column) {
      if (column.prop == "storeId") {
        this.otherParam.storeId = value.id;
        this.$refs.listOperationForm.formModel.storeId = value.id;
      }
    },
    search() {
      if (this.goodsTxt === '' || this.goodsTxt === null) return;
      this.otherParam.otherName = this.goodsTxt;
      this.isCheck = true;
      this.$axios
        .fetchPost(api.warehouse.warehouseGoods + "/list", this.otherParam)
        .then(res => {
          if (res.code === 200) {
            if (res.data.length > 0) {
              let tableData = res.data;
              if (tableData.length === 1) {
                let row = tableData[0];
                row.paPurchasePrice = row.purchasePrice;
                let tableList = this.$refs["listOperation"].getTabelData();
                let flag = true;
                if (tableList.length > 0) {
                  tableList.forEach(item => {
                    if (flag) {
                      if (item.barCode === row.barCode) flag = false;
                    }
                  });
                }
                if (!flag) {
                  this.$message.warning("[名称:" + row.goodsName + ",条码:" + row.barCode + "],已存在！！！");
                  return;
                }
                this.$refs["listOperation"].setColumnData(row, tableList.length);
                this.currentTableList = this.$refs["listOperation"].getTabelData();
                this.$message.success("商品添加成功");
              } else {
                this.checkGoods();
              }
            } else {
              this.$message.warning("[条码:" + this.goodsTxt + "],商品不存在！！！");
            }
          } else {
            this.$message({type: "error", message: res.msg});
          }
        })
        .catch(err => {
        }).finally(() => {
        this.clearQueryParam();
        this.isCheck = false;
      });
    },
    clearQueryParam() {
      this.goodsTxt = '';
      this.otherParam.otherName = '';
    },
    setStore() {
      let storeId = this.$utils.getSysUser().storeId;
      if (storeId) {
        this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].defaultValue = storeId;
        this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].disabled = true;
      } else {
        this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].defaultValue = -1
      }
    },
    // 输入现成本价
    purchaseChange(val, index) {
      if (index != null && index !== '') {
        let rowData = this.$utils.deepClone(this.currentTableList[index]);
        if (val.paPurchasePrice === '' || val.paPurchasePrice == null) {
          val.paPurchasePrice = rowData.paPurchasePrice.toString();
          return;
        }
      }
      let value = 0;
      if (val.paPurchasePrice && val.purchasePrice && val.goodsNum) {
        value = (val.paPurchasePrice - val.purchasePrice) * val.goodsNum
      }
      val.differencePrice = value.toFixed(2)
      this.$refs["listOperation"].setColumnData(val, index);
    },
    // 编辑详情
    getDetail(id) {
      this.loading = true;
      this.$axios
        .fetchGet(api.warehouse.adjustmentOrder + '?id=' + id, {})
        .then(data => {
          this.loading = false;
          if (data.code === 200 && data.data) {
            this.formModel = data.data;
            if (this.formModel.reviewerStatus === 10) {
              this.listFormOptions.disabled = true;
              this.listColumns.disabled = true;
              this.buttonShow = true;
              this.auditShow = true;
            } else {
              this.listFormOptions.disabled = false;
              this.listColumns.disabled = false;
              this.buttonShow = false;
              this.auditShow = false;
            }
            // this.otherParam.storeId = data.data.storeId;
            //选择门店的时候，查询商户相应的门店
            this.$refs.listOperationForm.formModel.storeId = data.data.storeId;
            this.$nextTick(() => {
              this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].disabled = true;
              this.$refs.listOperationForm.setFormModel(data.data);
              //为表格赋值
              this.$refs['listOperation'].addMoreRow(data.data.wePurchaseAdjustmentGoodsMapMVOList, 0);
              this.currentTableList = this.$refs['listOperation'].getTabelData();
            });
            // this.priceTypeChange({types: data.data.types});
          } else if (data.code === 200 && !data.data) {
            this.$message({message: '获取数据出错！', type: 'error'});
            this.$router.push({path: '/warehouse/purchase/adjustment'});
          } else {
            this.$message({message: data.msg, type: 'error'});
          }
        })
        .catch(err => {
          this.$message({message: '请求失败！', type: 'error'});
          this.loading = false;
        });
    },
    // 选择调价门店
    getSelectParam(row) {
      if (this.$refs["listOperation"] && this.$refs['listOperation'].getTabelData().length > 0 && !this.$route.query.id) {
        this.$refs["listOperation"].clearTableData();
      }
      this.otherParam.storeId = row.storeId
    },
    // 点击选择商品
    checkGoods() {
      // if (!this.otherParam.storeId) {
      //   this.$message({
      //     type: 'warning',
      //     message: '请先选择门店',
      //   })
      // } else {
      this.listShow = true;
      this.goodListSelect = true;
      this.$nextTick(() => {
        this.otherParam = {...this.otherParam, ...this.supplierInfo};
      })
      // }
    },
    // 多商品选择 确认
    rowsSelectSubmit(rows) {
      this.listShow = false;
      rows.forEach(v => {
        v.goodsNum = v.inventoryNum
        v.paPurchasePrice = v.purchasePrice
        this.purchaseChange(v)
      })
      let tableList = this.$refs['listOperation'].getTabelData();
      this.$refs['listOperation'].addMoreRow(rows, tableList.length);
      this.listTableData = this.$refs["listOperation"].getTabelData();
      this.currentTableList = this.$refs['listOperation'].getTabelData();
      if (rows && rows.length > 0) {
        this.$message.success("商品添加成功");
      }
    },

    //选择某行数据
    rowCheck(row) {
      this.listShow = false;
      row.goodsNum = row.inventoryNum
      row.paPurchasePrice = row.purchasePrice
      this.purchaseChange(row)
      this.$refs['listOperation'].setColumnData(row, this.checkIndex);
      this.listTableData = this.$refs["listOperation"].getTabelData();
      this.currentTableList = this.$refs['listOperation'].getTabelData();
    },
    //提交数据
    submitAuth() {
      if (!this.isCheck) {
        let param = this.getParams();
        // if (!this.otherParam.storeId) {
        //   this.$message({
        //     type: 'warning',
        //     message: '请选择门店',
        //   })
        // } else
        if (param.wePurchaseAdjustmentGoodsMapMVOList.length == 0) {
          this.$message({message: '商品信息无效！', type: 'warning'});
        } else {
          let flag = false;
          let testSave = false
          param.wePurchaseAdjustmentGoodsMapMVOList.forEach(v => {
            if (v.paPurchasePrice === 0) {
              flag = true
            }
          });
          testSave = param.wePurchaseAdjustmentGoodsMapMVOList.every(v => {
            if (v.goodsName) {
              return true
            } else {
              return false
            }
          })
          if (testSave) {
            if (flag) {
              this.$confirm('存在调价为0？确认')
                .then(_ => {
                  this.requestData(param);
                }).catch(() => {
              })
            } else {
              this.requestData(param);
            }
          }
        }
      }
    },
    requestData(param) {
      const loading = this.$loading({
        lock: true,
        text: '提交中，请稍候...',
        background: 'rgba(225, 225, 225, 0.8)',
      });
      this.$axios
        .fetchPost(api.warehouse.adjustmentOrder, param)
        .then(data => {
          this.loading = false;
          if (data.code === 200) {
            this.auditShow = false;
            this.buttonShow = false;
            this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].disabled = true;
            // this.listFormOptions.columns.filter(item => item.prop === 'relateType')[0].disabled = true;
            this.$refs.listOperationForm.setFormModel(data.data);
            this.$notify({
              type: "success",
              title: '保存操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({message: '商品调价操作成功', type: 'success'});
            if (data.data) {
              this.getDetail(data.data.id)
            }
          } else {
            this.$notify({
              type: "error",
              title: '保存操作',
              message: data.msg,
              showClose: false,
            });
          }
        }).catch(err => {
        this.$notify({
          type: "error",
          title: '保存操作',
          message: '失败',
          showClose: false,
        });
      }).finally(() => {
        loading.close();
      });
    },

    // 审核
    audit() {
      if (!this.isCheck) {
        const loading = this.$loading({
          lock: true,
          text: '审核中，请稍候...',
          background: 'rgba(225, 225, 225, 0.8)',
        });
        let param = this.getParams()
        this.$axios
          .fetchPost(api.warehouse.adjustmentOrderAudit + '/audit', param)
          .then(data => {
            this.loading = false;
            if (data.code == 200) {
              this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].disabled = true;
              // this.listFormOptions.columns.filter(item => item.prop === 'relateType')[0].disabled = true;
              this.auditShow = true;
              this.buttonShow = true;
              this.$refs.listOperationForm.setFormModel(data.data);
              this.$notify({
                type: "success",
                title: '审核操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '审核成功', type: 'success'});
              this.$router.push({path: '/warehouse/purchase/adjustment'});
            } else {
              this.$notify({
                type: "error",
                title: '审核操作',
                message: data.msg,
                showClose: false,
              });
              // this.$message({message: data.msg, type: 'error'});
            }
          }).catch(err => {
          // this.$message({message: '请求失败！', type: 'error'});
          this.$notify({
            type: "error",
            title: '审核操作',
            message: '失败',
            showClose: false,
          });
        }).finally(() => {
          loading.close();
        });
      }
    },
    getParams() {
      let tableList = this.$refs['listOperation'].getTabelData();
      let orderNumber = 1;
      tableList.map(item => {
        item.orderNumber = orderNumber++;
        if (item.goodsId == null) {
          item.goodsId = item.id;
        }
      });
      let totalParam = this.$refs['listOperation'].getSumData();
      let headParam = this.$refs.listOperationForm.getFormModel();
      totalParam.orderPrice = totalParam.cleanPrice;
      return {
        ...{wePurchaseAdjustmentGoodsMapMVOList: tableList}, ...totalParam, ...headParam,
      }
    },
    //返回按钮事件
    beBack() {
      if (!this.isCheck) {
        this.$router.go(-1);
      }
    },
    refresh() {
      if (!this.isCheck) {
        this.$router.go(0);
      }
    },
    downloadTemplate() {

    },
    importData() {

    }
  }
}
</script>
<style scoped>
  >>> .el-dialog__header {
    margin-bottom: 5px;
  }

  .order-add-page .search-goods-box {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .order-add-page .search-goods-box .select-good {
    margin-left: 16px;
  }

  .search-goods-input {
    width: 300px;
  }

  /deep/ #goodsText {
    height: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/page/warehouse/purchase/adjustmentAdd.vue